import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Icons } from '@/src/modules/components/Icons';

export function MobileBottomNav() {
  const location = useLocation();

  const isHome = location.pathname === '/dashboard' || location.pathname === '/dashboard/';
  const isInvites = location.pathname.startsWith('/dashboard/invitations');
  const isWizard = location.pathname.startsWith('/wizard');

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 h-16 bg-surface/80 backdrop-blur-lg border-t border-outline-variant/20 flex justify-around items-center px-4 z-50">
      {isHome ? (
        <button
          disabled
          aria-disabled="true"
          aria-label="Home"
          className="flex flex-col items-center gap-1 text-primary cursor-default opacity-100 focus-visible:outline-none rounded-lg p-1"
        >
          <Icons.Home size={20} />
          <span className="text-[10px] font-bold">Home</span>
        </button>
      ) : (
        <Link
          to="/dashboard"
          aria-label="Home"
          className="flex flex-col items-center gap-1 text-on-surface-variant hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-lg p-1"
        >
          <Icons.Home size={20} />
          <span className="text-[10px] font-bold">Home</span>
        </Link>
      )}

      {isInvites ? (
        <button
          disabled
          aria-disabled="true"
          aria-label="Invites"
          className="flex flex-col items-center gap-1 text-primary cursor-default opacity-100 focus-visible:outline-none rounded-lg p-1"
        >
          <Icons.Calendar size={20} />
          <span className="text-[10px] font-bold">Invites</span>
        </button>
      ) : (
        <Link
          to="/dashboard/invitations"
          aria-label="Invites"
          className="flex flex-col items-center gap-1 text-on-surface-variant hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-lg p-1"
        >
          <Icons.Calendar size={20} />
          <span className="text-[10px] font-bold">Invites</span>
        </Link>
      )}

      {isWizard ? (
        <button
          disabled
          aria-disabled="true"
          aria-label="Create"
          className="flex flex-col items-center gap-1 text-primary cursor-default opacity-100 focus-visible:outline-none rounded-lg p-1"
        >
          <Icons.Plus size={20} />
          <span className="text-[10px] font-bold">Create</span>
        </button>
      ) : (
        <Link
          to="/wizard"
          aria-label="Create"
          className="flex flex-col items-center gap-1 text-on-surface-variant hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-lg p-1"
        >
          <Icons.Plus size={20} />
          <span className="text-[10px] font-bold">Create</span>
        </Link>
      )}
    </nav>
  );
}
